export default function (value, precision, minimumFractionDigits = 2) {
    if (!value && value !== 0) {
        return '';
    }

    if (typeof value === 'number') {
        return (value / 100).toLocaleString(undefined, { style: 'percent', minimumFractionDigits, maximumFractionDigits: precision });
    }

    return (Number.parseInt(value.percent, 10) / (100 * 100)).toLocaleString(undefined, { style: 'percent', minimumFractionDigits, maximumFractionDigits: precision });
}
